import objectFitImages from 'object-fit-images';
import MobMenu from './../util/MobMenu';
import Menu from './../util/Menu';

export default {
  init() {
    // JavaScript to be fired on all pages
    objectFitImages();
    new Menu(".menu");
    new MobMenu("mobile-menu");
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js